<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title class="subheading">
            Geolocalización
          </v-card-title>
          <v-container grid-list-xs>
            <v-form ref="form" lazy-validation>
              <v-layout wrap ma-4 mt-0>
                <v-flex md12 sm12>
                  <v-text-field prepend-icon="location_on" label="Latitude" hint="Latitud de la oficina"
                    v-model="geoData.geoLatitude"></v-text-field>
                </v-flex>
                <v-flex md12 sm12>
                  <v-text-field prepend-icon="location_on" label="Longitud" hint="Longitud de la oficina"
                    v-model="geoData.geoLongitude"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <btn-largo text="Guardar" fontColor="white--text" color="white--text" :bgcolor="bgColor"
                    v-if="!loading" @click.native="submit" :disabled="botonDeshabilitado"></btn-largo>
                </v-flex>
              </v-layout>
            </v-form>
            <v-alert type="success" v-if="fin">
              Se ha guardado la ubicación de la empresa correctamente
              <v-divider class="my-4 success" style="opacity: 0.22"></v-divider>
              <v-row align="center" no-gutters>
                <v-col class="grow"></v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-alert>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import enterpriseGeoServices from "@/services/enterpriseGeoService.js";
import btnLargo from "@/components/commons/btnLargo";

export default {
  created() {
    this.$store.commit("global/SET_MIGA", [
      { text: "Inicio", href: "/" },
      { text: "GeolocationConfig", href: "/geolocation-config" }
    ]);
  },
  components:{
    btnLargo,
  },
  mounted() {
    this.loadGeoData();
  },
  props: {
    isPublic: {
      type: String,
      defualt: "false"
    }
  },
  data() {
    return {
      geoData: {
        enterpriseId: null,
        geoLatitude: null,
        geoLongitude: null,
        geoAccuaracy: null
      },
      loading: false,
      botonDeshabilitado: false,
      bgColor: "blue",
      fin: false,
    };
  },
  computed: {
    ...mapState("global", ["soporteCorreo"]),
  },
  methods: {
    async loadGeoData() {
      try {
        this.loading = true;
        const id = 1;
        const response = await enterpriseGeoServices.getEnterpriseGeo();
        this.geoData = response;
      } catch (error) {
        console.error("Error al cargar datos de geolocalización", error);
      } finally {
        this.loading = false;
      }
    },
    async submit() {
      try {
        this.loading = true;
        await enterpriseGeoServices.updateEnterpriseGeo(this.geoData);
        this.fin = true;
      } catch (error) {
        console.error("Error al actualizar datos", error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
<style scoped>
.container.container--fluid>>>.v-expansion-panel-header.v-expansion-panel-header--active {
  background-color: #1565c0 !important;
  color: #fff;
}
</style>